import { SlideOutSheet } from '@/components/SlideOutSheet';
import { Info } from 'lucide-react';

import { cn } from '@design-system';

import type { ReactNode } from 'react';

type MethodologyCalloutVariant = 'content' | 'icon';

interface MethodologyCalloutProps {
  content: JSX.Element;
  title?: string;
  variant?: MethodologyCalloutVariant;
  label?: string;
  maxWidth?: string;
  className?: string;
  iconClassName?: string;
  'data-testid'?: string;
  children?: ReactNode
}

export function MethodologyCallout({
  content,
  title = 'FAQ',
  maxWidth,
  className,
  iconClassName,
  variant,
  children,
  'data-testid': dataTestId,
}: MethodologyCalloutProps) {
  return (
    <SlideOutSheet
      slideOutContent={content}
      title={title}
      maxWidth={maxWidth}
    >
      {variant === 'content' ? (
        children
      ) : (
        <Info
          className={cn(
            'text-muted-foreground hover:text-primary size-4 shrink-0 transition-colors',
            className,
            iconClassName,
          )}
          aria-hidden="true"
          data-testid={dataTestId ?? 'methodology-callout-icon'}
        />
      )}
    </SlideOutSheet>
  );
}
